import { fetchConsentPreferences } from '../../../services/consent-hub-service';
import { checkTokenValidity } from '../transformer';
export const getValidConsentData = async fallbackConsentToken => {
  // Fetches preferences from ConsentHub and returns serialized token data if possible
  const consentData = await fetchConsentPreferences();
  let {
    consentToken,
    currentLocale,
    consentTimestamp,
    consentHubInaccessible
  } = consentData;
  let {
    isValid
  } = checkTokenValidity(consentToken);
  if (isValid && consentHubInaccessible && fallbackConsentToken) {
    // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
    // any previously set consents in the interim if we have them.
    consentToken = fallbackConsentToken;
  }
  return isValid ? {
    consentToken,
    currentLocale,
    consentTimestamp
  } : undefined;
};